// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"_d4623d6","gameOverlayModal":"_bea2fd9","mobile":"_7fca7a8"};